import z from "zod";
import { Renewal, RenewalWelder } from "@/api/williams/renewals";

const REQUIRED_FIELD_ERROR = "Required Field";

export const RenewalWelderSchema = z
  .object({
    welderId: z.string(),
    name: z.string(),
    basic: z.string().nullish(),
    cfr192: z.string().nullish(),
    cfr195: z.string().nullish(),
    basicNde: z.string().nullish(),
    update: z.boolean(),
    reinstatement: z.boolean(),
  })
  .transform((data) => data as RenewalWelder);

export const RenewalSchema = z
  .object({
    process: z.string().nonempty(REQUIRED_FIELD_ERROR),
    technique: z.string().nonempty(REQUIRED_FIELD_ERROR),
    testType: z.string().nonempty(REQUIRED_FIELD_ERROR),
    ndeMethod: z.string().nonempty(REQUIRED_FIELD_ERROR),
    acceptanceCriteria: z.string().nonempty(REQUIRED_FIELD_ERROR),
    result: z.string().nonempty(REQUIRED_FIELD_ERROR),
    ndeDate: z.string().nonempty(REQUIRED_FIELD_ERROR),
    weldDate: z.string().nonempty(REQUIRED_FIELD_ERROR),
    notes: z.string(),
    attachment: z.instanceof(File).nullable().optional(),
    welders: z.array(RenewalWelderSchema).nullish(),
  })
  .transform((data) => data as Renewal)
  .superRefine((data, ctx) => {
    if (!data.attachment && data.ndeMethod !== "None") {
      ctx.addIssue({
        path: ["attachment"],
        code: z.ZodIssueCode.custom,
        message: "Please select an attachment",
      });
    }

    if (new Date(data.ndeDate) < new Date(data.weldDate)) {
      ctx.addIssue({
        path: ["ndeDate"],
        code: z.ZodIssueCode.custom,
        message: "NDE Date must be after weld date",
      });
    }
  });
